import React, { createContext, useContext, useState, useEffect, ReactNode } from "react";

interface BuildingContextType {
  buildingId: string | null;
  apartmentId: string | null;
  apartmentName: string | null;
  setBuildingData: (buildingId: string, apartmentId: string, apartmentName: string) => void;
  clearBuildingData: () => void;
}

const BuildingContext = createContext<BuildingContextType | undefined>(undefined);

export const BuildingProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [buildingId, setBuildingId] = useState<string | null>(() => localStorage.getItem('buildingId'));
  const [apartmentId, setApartmentId] = useState<string | null>(() => localStorage.getItem('apartmentId'));
  const [apartmentName, setApartmentName] = useState<string | null>(() => localStorage.getItem('apartmentName'));

  useEffect(() => {
    if (buildingId) {
      localStorage.setItem('buildingId', buildingId);
    } else {
      localStorage.removeItem('buildingId');
    }
  }, [buildingId]);

  useEffect(() => {
    if (apartmentId) {
      localStorage.setItem('apartmentId', apartmentId);
    } else {
      localStorage.removeItem('apartmentId');
    }
  }, [apartmentId]);

  useEffect(() => {
    if (apartmentName) {
      localStorage.setItem('apartmentName', apartmentName);
    } else {
      localStorage.removeItem('apartmentName');
    }
  }, [apartmentName]);

  const setBuildingData = (building: string, apartment: string, name: string) => {
    setBuildingId(building);
    setApartmentId(apartment);
    setApartmentName(name);
  };

  const clearBuildingData = () => {
    setBuildingId(null);
    setApartmentId(null);
    setApartmentName(null);
  };

  return (
    <BuildingContext.Provider value={{ buildingId, apartmentId, apartmentName, setBuildingData, clearBuildingData }}>
      {children}
    </BuildingContext.Provider>
  );
};

export const useBuilding = (): BuildingContextType => {
  const context = useContext(BuildingContext);
  if (!context) {
    throw new Error("useBuilding must be used within a BuildingProvider");
  }
  return context;
};
